import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'limitarTexto'
})
export class LimitarTextoPipe implements PipeTransform {

  transform(valor: string, max: number = 50): string {

    if (!valor) return '';

    if (valor.length <= max) {
      return valor;
    }

    return valor.substring(0, max) + '...';
  }

}